import config from '@/config/config.js';
import { http } from '@/common/request';
import errorCode from '@/api/error-code.js'
export default {
    /***************************************************** start *******************************************/



    getCaptcha(type){
        let params = {type:type }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/common/captcha/getCaptcha",data, method: 'GET', ...options});
    },









    /***************************************************** end *********************************************/
}
